import Grid from '@mui/material/Grid'
import React, { forwardRef } from 'react'

import CustomTextField from '../../../@core/components/mui/text-field'
import CustomAutocomplete from '../../../@core/components/mui/autocomplete'
import Button from '@mui/material/Button'
import Icon from '../../../@core/components/icon'
import format from 'date-fns/format'
import Box from '@mui/system/Box'
import { useTheme } from '@mui/material/styles'
import DatePicker from 'react-datepicker'

import "react-datepicker/dist/react-datepicker.css";
// import CustomInput from 'src/component/ui/datePicker/PickersCustomInput'
// import 'react-datepicker/dist/react-datepicker.css'

const Search = ({ date, setDate, handleSubmitReport, handleClear, claimList, accountTypeList, handleOnChange, selectedAccount, setSelectedAccount, selectedClaim, setSelectedClaim, userList, setUserList, selectedAccountType, setSelectedAccountType, startDateRange, endDateRange, showExport }) => {
  const theme = useTheme()

  const CustomInput = forwardRef((props, ref) => {
    // Handle empty value for start and end dates
    const startDateFormatted = props.start ? format(props.start, 'MM/dd/yyyy') : ''
    const endDateFormatted = props.end ? format(props.end, 'MM/dd/yyyy') : ''
    const value = `${startDateFormatted}${endDateFormatted ? ' - ' + endDateFormatted : ''}`

    return <CustomTextField inputRef={ref} label={props.label || ''} {...props} width='100%' value={value} placeholder="Start Date - End Date" />
  })

  return (
    <>
      {/* <Box sx={{
        p: 2, background: theme.palette.grey[50], borderRadius: "10px",
      }}> */}
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={6} lg={6} xl={2}>
            <DatePicker
              style={{ width: "100%" }}
              selectsRange
              monthsShown={2}
              endDate={endDateRange}
              selected={startDateRange}
              startDate={startDateRange}
              shouldCloseOnSelect={false}
              placeholder="select Date"
              id='date-range-picker-months'
              onChange={handleOnChange}
              customInput={<CustomInput end={endDateRange} start={startDateRange} />}
            />
          </Grid>

          <Grid item xs={12} sm={8} md={6} lg={6} xl={2}>
            <CustomAutocomplete
              autoHighlight
              sx={{ width: '100%' }}
              options={accountTypeList}
              value={selectedAccountType}
              onChange={(event, newValue) => newValue ? setSelectedAccountType(newValue) : setSelectedAccountType({type: 'platform Email', value: 'meesho'}) }
              id='autocomplete-autoHighlight'
              getOptionLabel={option => option.type || "platform Email"}
              renderInput={params => <CustomTextField {...params} placeholder='Select Type' />}
            />
          </Grid>
          <Grid item xs={12} sm={8} md={6} lg={6} xl={2}>
            <CustomAutocomplete
              autoHighlight
              sx={{ width: '100%' }}
              options={claimList}
              value={selectedClaim}
              onChange={(event, newValue) => setSelectedClaim(newValue)}
              id='autocomplete-autoHighlight'
              getOptionLabel={option => option.type || ''}
              renderInput={params => <CustomTextField {...params} placeholder='Select Claim' />}
            />
          </Grid>
          <Grid item xs={12} sm={8} md={6} lg={6} xl={2}>
            <CustomAutocomplete
              autoHighlight
              sx={{ width: '100%' }}
              options={userList}
              id='autocomplete-autoHighlight'
              value={selectedAccount}
              onChange={(event, newValue) => setSelectedAccount(newValue)}
              getOptionLabel={option => option.email || ''}
              renderInput={params => <CustomTextField {...params} placeholder='Select Account' />}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
            <div style={{ display: "flex" }}>
              <Button variant='contained' sx={{ marginLeft: "8px" }} onClick={handleSubmitReport}>Filter</Button>
              <Button variant='tonal' sx={{ marginLeft: "8px" }} onClick={handleClear}>Clear</Button>
            </div>
          </Grid>
          {showExport ?
            <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button variant='tonal' startIcon={<Icon icon="material-symbols:upload-rounded" />} style={{ marginRight: "10px", color: "rgb(0 169 75)", background: "#28c76f29" }}>Export</Button>
                {/* <Button variant='tonal' startIcon={<Icon icon="material-symbols:download-rounded" />} style={{ background: "#cf8717", color: "white", }}>Import</Button> */}
              </div>
            </Grid>
            :
            ''}
        </Grid>
      </Box>
    </>
  )
}

export default Search
